import { useRecoilState, useRecoilValue } from 'recoil';
import {
  scanModeInputAtom,
  searchDownPaymentInputAtom,
} from 'containers/deal/recoil/atoms';
import { MSAPIScanMode } from 'shared/types/marketScan';
import StyledTextField from 'components/atoms/TextField';
import { InputAdornment, Typography } from '@mui/material';
import { moneyFormat } from 'shared/utils/functions';
import { useScreenSize } from 'hooks/useScreenSize';
import { useEffect, useState } from 'react';
import { DEFAULT_DOWN_PAYMENT } from 'data/constants';
import { styled } from '@mui/material/styles';
import { SxProps } from '@mui/system';
import { Theme as ThemeMui5 } from '@mui/material/styles/createTheme';
import useDebounce from 'hooks/useDebounce';

const Container = styled('div')(
  ({ theme }) => `
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-top: ${theme.spacing(1.5)};`,
);

const textFieldStyles: (isMobile?: boolean) => SxProps<ThemeMui5> =
  (isMobile) => (theme) => ({
    '&.MuiTextField-root': {
      marginTop: '0',
      width: isMobile ? '60%' : 130,
      '& .MuiOutlinedInput-adornedEnd': {
        paddingRight: isMobile ? theme.spacing(0.5) : theme.spacing(2),
      },
    },
  });

export const EditSearchDownPayment = () => {
  const { isExtraSmallScreen, isSmallScreen } = useScreenSize();
  const isMobile = isExtraSmallScreen || isSmallScreen;
  const scanMode = useRecoilValue(scanModeInputAtom);
  const isFinance = scanMode === MSAPIScanMode.Retail;
  const [downPaymentAtom, setDownPaymentAtom] = useRecoilState(
    searchDownPaymentInputAtom,
  );
  const [downPayment, setDownPayment] = useState(
    downPaymentAtom || DEFAULT_DOWN_PAYMENT,
  );

  const debouncedDownPayment = useDebounce(downPayment, 1500);

  useEffect(() => {
    if (debouncedDownPayment) {
      setDownPaymentAtom(debouncedDownPayment);
    }
  }, [debouncedDownPayment, setDownPaymentAtom]);

  const onChangeHandler = (event) => {
    const value = event.target?.value.replace(/,/g, '');
    const downPaymentVal = value.length ? parseFloat(value) : 0;
    setDownPayment(downPaymentVal);
  };

  if (!isFinance) {
    return null;
  }

  return (
    <Container>
      <Typography variant='body1' style={{ marginLeft: '8px' }}>
        Cash down
      </Typography>
      <StyledTextField
        sx={textFieldStyles(isMobile)}
        variant={isMobile ? 'outlined' : 'standard'}
        type='text'
        inputProps={{
          style: { paddingLeft: 0, paddingRight: 0 },
        }}
        InputProps={{
          startAdornment: <InputAdornment position='start'>$</InputAdornment>,
        }}
        value={moneyFormat(downPayment).replace('$', '')}
        onChange={onChangeHandler}
      />
    </Container>
  );
};
